import {
  // pubComment,
  pubComment2,
  getUserHomeUrl
} from '@/api/actions'
import {toast} from '../../utils/index'
import hhkjsq from '@/common/hhkjsq.js'
const {app, hosts, isIPhone} = hhkjsq
// 评论相关的数据模型和请求
export default {
  state: {
    // 评论内容
    content: {
      comTxt: '',
      imagePath: ''
    },

    // 是否在发布
    pubbing: false,

    // 是否在上传图片
    imgloading: false,

    // 显示
    show: false,

    // 前一条评论信息
    preComment: {
      preCommentID: 0,
      preCommentInfo: null
    },

    scrollTop: 0
  },

  actions: {
    // 发布评论
    pubComment ({state, dispatch, rootState}) {
      if (state.pubbing || state.imgloading) {
        return
      }
      state.pubbing = true
      var requestData = {
        InfoID: rootState.header.pageInfo.PostId,
        ComTxt: encodeURIComponent(state.content.comTxt),
        TopicUserName: rootState.header.pageInfo.PrensenterName,
        UserID: rootState.header.pageInfo.PresenterId,
        PreCommentID: state.preComment.preCommentID,
        ImagePath: state.content.imagePath
      }
      pubComment2({
        params: requestData,
        success: function (response) {
          if (response.CommentID < 0) {
            toast(response.Message)
            return
          }
          let now = new Date()
          // 回复的评论显示不超过100个字符
          let preCommentInfo = state.preComment.preCommentInfo ? Object.assign({}, state.preComment.preCommentInfo, {
            CommentContent: state.preComment.preCommentInfo.CommentContent.length > 100
              ? state.preComment.preCommentInfo.CommentContent.substring(0, 100) + '...'
              : state.preComment.preCommentInfo.CommentContent
          }) : state.preComment.preCommentInfo
          // 存储在本地的评论信息
          let localItem = Object.assign({}, requestData, {
            CommentID: response.CommentID,
            CreateTimeToInt: now.getTime() / 1000,
            CommentContent: decodeURIComponent(requestData.ComTxt),
            PreCommentInfo: preCommentInfo,
            UserName: app.getUserName(),
            UserID: app.getUserId(),
            UserHeadUrl: hosts.usertxcdn + '/info/getheadpic?id=' + app.getUserId(),
            UserHomeUrl: getUserHomeUrl(app.getUserName()),
            ShowStatus: 0
          })

          // 评论之后切换到全部精华列表
          state.pubbing = false
          dispatch('hideCommentArea')
          dispatch('changActiveId', 'all')
          dispatch('unshiftAllComment', localItem)
          if (isIPhone) {
            document.body.className = ''
          }
          window.scrollTo(0, 0)
          if (isIPhone) {
            window.scrollTo(0, 0.1)
          }
        },
        error: function (error) {
          toast('评论失败')
          state.pubbing = false
          throw new Error(error)
        }
      })
    },

    // 显示评论框，初始化评论信息，并更新回复评论的信息
    showCommentArea ({state}, preComment) {
      state.show = true
      state.content.comTxt = ''
      state.content.imagePath = ''
      state.preComment.preCommentID = preComment ? preComment.preCommentID : 0
      state.preComment.preCommentInfo = preComment ? preComment.preCommentInfo : null
      window.$('#j-comment-box').focus()
    },

    // 隐藏评论框
    hideCommentArea ({state}) {
      state.show = false
    },

    // 处理上传图片格式
    handeleImagePath ({state}, imgList) {
      if (!imgList || imgList.length === 0) {
        state.content.imagePath = ''
        return
      }
      var arr = []
      for (let i = 0; i < imgList.length; i++) {
        let o = imgList[i]
        let temp = [o.id, o.src, i + 1, o.size].join(',')
        arr.push(temp)
      }
      state.content.imagePath = arr.join('|')
    },

    recordScrolltop ({state}) {
      state.scrollTop = document.body.scrollTop
    },

    focusbottom ({state, dispatch, rootState}, el) {
      if (isIPhone) {
        // document.body.className += 'f-one-view'
        dispatch('recordScrolltop')
        // rootState.loadmore = false
        // let scrollHeight = document.body.scrollHeight
        // window.scrollTo(0, scrollHeight)
      }
    },

    blurbottom ({state, rootState}) {
      if (isIPhone) {
        document.body.className = ''
        window.scrollTo(0, state.scrollTop)
        // rootState.loadmore = true
      }
    },

    changeImageUploading ({state}) {
      state.imgloading = !state.imgloading
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/comment.js